import React from "react";
import ReactECharts from "echarts-for-react";

export default function OrdersBar({ data, range, onRangeChange }) {
  const max = Math.max(...data.series[0].data);
  const option = {
    grid: { left: 32, right: 16, top: 48, bottom: 30 },
    tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
    xAxis: {
      type: "category",
      data: data.categories,
      axisTick: { show: false },
      axisLabel: {
        color: "#333",
        fontSize: 11,
      },
    },
    yAxis: { type: "value", splitLine: { lineStyle: { color: "#f1ece6" } } },
    series: [
      {
        type: "bar",
        data: data.series[0].data.map((v) => ({
          value: v,
          itemStyle: {
            color: v === max ? "#ff7a00" : "#ff7a00",
          },
        })),
        barWidth: "50%",
        emphasis: { focus: "series" },
        itemStyle: { borderRadius: [6, 6, 0, 0] },
      },
    ],
  };

  const handleRangeChange = (e) => {
    const newRange = e.target.value;
    onRangeChange(newRange);
  };

  return (
    <>
      <div className="card-title-row">
        <div className="card-title">Orders Overview</div>

        <select
          value={range}
          onChange={handleRangeChange}
          className="custom-select"
        >
          <option value="this_month">This Month</option>
          <option value="1w">1W</option>
          <option value="1m">1M</option>
          <option value="3m">3M</option>
          <option value="6m">6M</option>
          <option value="1y">1Y</option>
        </select>
      </div>

      <div className="echart" style={{ height: 300 }}>
        <ReactECharts option={option} notMerge lazyUpdate />
      </div>
    </>
  );
}
